var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BaseNode",class:{
    BaseNode__hasError: _vm.hasError
  },style:({
    '--node-color': _vm.color
  })},[_c('div',{staticClass:"BaseNode_container"},[_c('div',{staticClass:"BaseNode_header"},[_c('div',{staticClass:"BaseNode_title"},[_vm._v(_vm._s(_vm.fullTitle))]),(_vm.icon)?_c('Icon',{attrs:{"icon":_vm.icon}}):_vm._e()],1),(_vm.$slots.default)?_c('div',{staticClass:"BaseNode_content"},[_vm._t("default")],2):_vm._e(),_c('div',{staticClass:"BaseNode_name"},[_vm._v(_vm._s(_vm.node.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }